class DateNoTz {
  constructor(dateTime) {
    this.dateString = null;
    this.timeString = null;
    this.printString = null;

    this.year = null;
    this.month = null;
    this.day = null;
    this.hours = null;
    this.minutes = null;
    this.seconds = null;

    if (!dateTime) {
      return;
    } else if (typeof dateTime == "string") {
      dateTime = dateTime.trim();
      this.fromDateTimeString(dateTime)
    } else if (typeof dateTime == 'object' && !isNaN(Date.parse(dateTime))) {
      this.fromDateObject(dateTime)
    }
  }

  fromDateTimeString(dateTimeString) {
    let dateString = null;
    let timeString = null;
    this.printString = dateTimeString
    // Determin if date or date and time
    if (dateTimeString.length >= 11) {
      // Assumes "xxxx-xx-xx xx:xx:xx" format
      timeString = dateTimeString.substring(11, dateTimeString.length);
      dateString = dateTimeString.substring(0, 10);

      
    } else {
      dateString = dateTimeString;
      timeString = "00:00:00";
    }

    this.setDate(dateString);
    this.setTime(timeString);
  }
  fromDateObject(dateObject) {
    var isoString = dateObject.toISOString()
    var dateArr = isoString.split("T")
    this.setDate(dateArr[0])
    this.setTime(dateArr[1].substring(0, 5) + ":00")
  }

  setDate(dateString) {
    // Deconstruct Date -- add more formats if necessary
    this.dateString = dateString;
    if (
      dateString &&
      dateString.match(
        /([12]\d{3}[-/](0[1-9]|1[0-2])[-/](0[1-9]|[12]\d|3[01]))/
      )
    ) {
      // YYYYMMDD format, for - and / delimiters
      let dateArr = null;
      if (dateString.indexOf("-") > -1) {
        dateArr = dateString.split("-");
      } else if (dateString.indexOf("/") > -1) {
        dateArr = dateString.split("/");
      }

      if (dateArr) {
        this.year = dateArr[0];
        this.month = dateArr[1];
        this.day = dateArr[2];

        var date = new Date(this.year + "/" + this.month + "/" + this.day);
        this.dayNumber = date.getDay();
      }
    }
  }

  setTime(timeString) {
    // Deconstruct Time -- add more formats if necessary
    this.timeString = timeString;
    if (
      timeString &&
      timeString.match(/(?:[01]\d|2[0-3]):(?:[0-5]\d):(?:[0-5]\d)/)
    ) {
      // YYYYMMDD format, for - and / delimiters
      let timeArr = null;
      if (timeString.indexOf(":") > -1) {
        timeArr = timeString.split(":");
      }

      if (timeArr) {
        this.hours = timeArr[0];
        this.minutes = timeArr[1];
        this.seconds = timeArr[2];
      }
    }
  }

  toString() {
    var stringified = "";
    if (this.dateString !== null) {
      stringified += this.year + "/" + this.month + "/" + this.day;
    }
    if (this.timeString !== null) {
      stringified += " " + this.hours + ":" + this.minutes + ":" + this.seconds;
    }
    return stringified;
  }

  asJsDate() {
    var jsDate = new Date(
      Date.UTC(
        this.year,
        this.month - 1,
        this.day,
        this.hours,
        this.minutes,
        this.seconds,
        0,
        0
      )
    );
    return jsDate;
  }

  convertToSeconds() {
    return (
      parseInt(this.seconds) +
      parseInt(this.minutes) * 60 +
      parseInt(this.hours) * 3600 +
      (parseInt(this.day) - 1) * 86400 +
      this.getMonthAsSecondsFromStartOfYear() +
      (parseInt(this.year) - 2000) * 31556926
    );
  }

  getMonthAsSecondsFromStartOfYear(){
    switch(this.month){
      case "01" : return 0;
      case "02" : return 2678400;
      case "03" : return 2678400 + 2419200;
      case "04" : return 2678400 + 2419200 + 2678400;
      case "05" : return 2678400 + 2419200 + 2678400 + 2592000;
      case "06" : return 2678400 + 2419200 + 2678400 + 2592000 + 2678400;
      case "07" : return 2678400 + 2419200 + 2678400 + 2592000 + 2678400 + 2592000;
      case "08" : return 2678400 + 2419200 + 2678400 + 2592000 + 2678400 + 2592000 + 2678400;
      case "09" : return 2678400 + 2419200 + 2678400 + 2592000 + 2678400 + 2592000 + 2678400 + 2678400;
      case "10" : return 2678400 + 2419200 + 2678400 + 2592000 + 2678400 + 2592000 + 2678400 + 2678400 + 2592000;
      case "11" : return 2678400 + 2419200 + 2678400 + 2592000 + 2678400 + 2592000 + 2678400 + 2678400 + 2592000 + 2678400;
      case "12" : return 2678400 + 2419200 + 2678400 + 2592000 + 2678400 + 2592000 + 2678400 + 2678400 + 2592000 + 2678400 + 2592000;
    }
  }

  shift(steps) {
    var baseDate = this.asJsDate()
    if (!baseDate) {
      baseDate = new Date();
    }
    baseDate.setDate(baseDate.getDate() + steps);
    this.fromDateObject(baseDate)
  }

  shiftDateWeekdaysOnly(steps) {
    var baseDate = this.asJsDate()
    if (!baseDate) {
      baseDate = new Date();
    }
    while (steps > 0) {
      baseDate.setDate(baseDate.getDate() + 1);
      if (baseDate.getUTCDay() !== 0 && baseDate.getUTCDay() !== 6) {
        steps--;
      } else {
      }
    }
    this.fromDateObject(baseDate)
  }

  shiftToNextInstanceOfDay(targetDay, isForward = true) {
    // Target Day: integer of day, Sun = 0 and Sat = 6. Defaults to Sunday
    // isForward: Looks for a date after base date if true, else looks for date before base date
    // Returns next Date of the targetDay
    var baseDate = this.asJsDate()
    if (!baseDate) {
      baseDate = new Date();
    }
    if (!targetDay) { // Default to Sunday
      targetDay = 0;
    }

    // Shift day
    var foundDate = new Date(baseDate);
    var step = isForward ? 1 : -1;
    for (let i = 0; i < 7; i++) {
      // Cap it at 7 to prevent infinite loops
      var dateNumber = foundDate.getDay()
      var utcDateNumber = foundDate.getUTCDay()
      var isoString = foundDate.toISOString()
      var utcString = foundDate.toUTCString()
      foundDate.setDate(foundDate.getDate() + step);
      if (foundDate.getUTCDay() == targetDay) {
        foundDate = foundDate;
        break;
      }
    }

    if (foundDate != baseDate) {
      this.fromDateObject(foundDate)
    }
  }

  getFullYear(){
    return this.year
  }
  // Formatting
  formatDdMonYyyy() {
    // DD Mon YYYY
    return `${this.getDateWithZero()} ${this.getMonthDescShort()} ${this.getFullYear()}`;
  }
  formatYYYYMMDD() {
    // YYYYMMDD
    return `${this.getFullYear()}${this.getMonthWithZero()}${this.getDateWithZero()}`;
  }
  formatYYYYMMDDTHHMMSSZ() {
    // YYYYMMDD
    return `${this.getFullYear()}${this.getMonthWithZero()}${this.getDateWithZero()}T${this.hours}${this.minutes}${this.seconds}Z`;
  }
  formatMonYyyy() {
    // Mmm YYYY
    return `${this.getMonthDescShort()} ${this.getFullYear()}`;
  }
  formatFullDayDdMonYyyy() {
    // Day, DD Mon YYYY
    return `${this.getDayDesc()},  ${this.getDateWithZero()} ${this.getMonthDescShort()} ${this.getFullYear()}`;
  }
  formatDayDdMonYyyy() {
    // Day, DD Mon YYYY
    return `${this.getDayDesc().substring(0, 3)},  ${this.getDateWithZero()} ${this.getMonthDescShort()} ${this.getFullYear()}`;
  }
  formatDayMonDdYyyy() {
    // Day, Mon DD YYYY
    return `${this.getDayDesc().substring(0, 3)}, ${this.getMonthDescShort()} ${this.getDateWithZero()} ${this.getFullYear()}`;
  }
  formatDayParMonDdYyyyPar() {
    // Day, Mon DD YYYY
    return `${this.getDayDesc()} (${this.getMonthDescShort()} ${this.getDateWithZero()} ${this.getFullYear()})`;
  }
  formatDayParDdMonYyyyPar() {
    // Day (Mon DD YYYY)
    return `${this.getDayDesc()} (${this.getDateWithZero()} ${this.getMonthDescShort()} ${this.getFullYear()})`;
  }

  getDayDesc() {
    var day = this.dayNumber;
    switch (day) {
      case 0:
        day = "Sunday";
        break;
      case 1:
        day = "Monday";
        break;
      case 2:
        day = "Tuesday";
        break;
      case 3:
        day = "Wednesday";
        break;
      case 4:
        day = "Thursday";
        break;
      case 5:
        day = "Friday";
        break;
      case 6:
        day = "Saturday";
        break;
    }
    return day;
  }
  getMonthDesc() {
    var month = this.month
    month = parseInt(month) - 1
    switch (month) {
      case 0:
        month = "January";
        break;
      case 1:
        month = "February";
        break;
      case 2:
        month = "March";
        break;
      case 3:
        month = "April";
        break;
      case 4:
        month = "May";
        break;
      case 5:
        month = "June";
        break;
      case 6:
        month = "July";
        break;
      case 7:
        month = "August";
        break;
      case 8:
        month = "September";
        break;
      case 9:
        month = "October";
        break;
      case 10:
        month = "November";
        break;
      case 11:
        month = "December";
        break;
    }
    return month;
  }

  getMonthDescShort(){
    var month = this.getMonthDesc()
    if(month){
      return month.substring(0,3)
    }
  }
  
  getMonthWithZero() {
    var month = this.month
    if (month && month.toString().length == 1) {
      month = '0' + month;
    }
    return month
  }
  getDateWithZero() {
    var date = this.day
    if (date && date.toString().length == 1) {
      date = '0' + date;
    }
    return date
  }
}

module.exports = DateNoTz;
